// The single React Query client for the app. Extracted from main.tsx so that
// non-component code (e.g. create/active-runs-store.ts, which fires a background
// POST decoupled from any component) can invalidate queries via
// `queryClient.invalidateQueries(...)`. There must be exactly one instance —
// import this everywhere; never `new QueryClient()` elsewhere.
import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 30_000 },
  },
});
